import React from "react";
import { observer } from "mobx-react";
import styles from "./_css/searchBarResult.module.css";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { IconComponent } from "components/base/icon/IconComponent";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { TGeoZoneMdl } from "geoZones/_models/GeoZoneMdl";

type Props = {
    purpose: PROPERTY_PURPOSE;
    onSelectGeoZone: (geoZone: TGeoZoneMdl) => void;
    onSelectProperty: (aliasUrl: string) => void;
};

export const SearchBarResult = observer((props: Props) => {
    const { t } = useTranslation();
    return (
        <>
            {geoZonesStore.results?.geoZones.length > 0 && (
                <div className={"pt_5 pb_0"}>
                    <h5 className={clsx("ml_10", styles.subTitle)}> {t("words.geoZones")} </h5>
                    {geoZonesStore.results.geoZones.map((geoZone, index) => {
                        const displayElem = [...geoZone.name.split(",")];
                        const title =
                            displayElem.length > 2 ? displayElem.splice(0, displayElem.length - 1) : displayElem;
                        return (
                            <div
                                key={geoZone._id}
                                className={clsx("position_relative pl_10 pr_20 pv_5", styles.row, {
                                    [styles.isSelectedRow]: geoZonesStore.selectedIndex === index,
                                })}
                                onMouseEnter={() => geoZonesStore.setSelectedIndex(index)}
                                onMouseLeave={() => geoZonesStore.setSelectedIndex(-1)}
                                onClick={() => props.onSelectGeoZone(geoZone)}
                            >
                                <div className={"flex_row_center"}>
                                    <IconComponent
                                        icon={"location_on"}
                                        fontSize={"inherit"}
                                        color={geoZonesStore.selectedIndex === index ? "primary" : "disabled"}
                                    />
                                    <div className={clsx("ml_5", styles.text)}>{title.join(",")}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {propertiesStore.propertiesSearch.length > 0 && (
                <div className={"pt_20 pb_0"}>
                    <h5 className={clsx("ml_10", styles.subTitle)}> {t("words.properties")} </h5>
                    {propertiesStore.propertiesSearch.map((property, index) => {
                        const oldIndex = geoZonesStore.results?.geoZones.length;
                        return (
                            <div
                                key={property._id}
                                className={clsx("position_relative pl_10 pr_20 pv_5", styles.row, {
                                    [styles.isSelectedRow]: geoZonesStore.selectedIndex === index + oldIndex,
                                })}
                                onMouseEnter={() => geoZonesStore.setSelectedIndex(oldIndex + index)}
                                onMouseLeave={() => geoZonesStore.setSelectedIndex(-1)}
                                onClick={async () => {
                                    props.onSelectProperty(property.localized.urlAlias);
                                    geoZonesStore.open(false);
                                }}
                            >
                                <div className={"flex_row_center"}>
                                    <IconComponent
                                        icon={"domainIcon"}
                                        fontSize={"inherit"}
                                        color={
                                            geoZonesStore.selectedIndex === index + oldIndex ? "primary" : "disabled"
                                        }
                                    />
                                    <div className={clsx("ml_5", styles.text)}>{property.localized.title}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {geoZonesStore.results.geoZones.length === 0 && propertiesStore.propertiesSearch.length === 0 && (
                <div className={"pt_5 pb_0"}>
                    <div className={clsx("p_20", styles.text)}>
                        {t("propertiesPage.searchBar.noResultsFor", { value: geoZonesStore.search })}
                    </div>
                </div>
            )}
        </>
    );
});
